import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Post from '../components/Post';
import ShowMore from '../components/ShowMore';

// Actions
import { peopleDataLoaded } from '../actions';

class Posts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postData: [],
      value: '',
      visibility: 'show',
      count: 6,
      showMoreVisibility: 'show',
      postDisplayNum: 6,
      zeroResults: false,
      query: false
    };
  }

  componentDidMount() {
    this.setState({ postData: this.props.postData });
    
  }

  formatDate(date) {
    let dateObj = new Date(date);
    let month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(dateObj);
    let day = dateObj.getDate();
    let year = dateObj.getFullYear();
    return `${month} ${day}, ${year}`;
  }

  buildPost = () => {
    //console.log(this.state.count)
    
    return this.state.postData.map((post, index) => {
      if (index < this.state.count) {
        return (
          <Post
            key={index}
            title={post.title}
            id={post.id}
            link={post.link}
            date={this.formatDate(post.date)}
          />
        );
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    //console.log(this.props.filteredPosts.filteredData.length)
    //console.log(prevProps)
    if (this.props.filteredPosts.filteredData.length !== prevProps.filteredPosts.filteredData.length) {
      
      this.setState({
        query: true,
        postData: this.props.filteredPosts.filteredData,
        showMoreVisibility: this.props.filteredPosts.filteredData.length < 6 ? 'hide' : 'show'
      })
    }

    /*if (this.state.query === false) {
      
      //console.log(this.props)      
          this.setState({
            query: true,
            postData: this.props.postData
          })
    }*/
    if (this.props.filters.query.active) {
        //console.log('prevstate');
        //console.log(prevState)
        //console.log('prevState');
        //console.log(prevState);
        //console.log('prevProps');
        //console.log(prevProps)
       
      //console.log(this.state.postData)
      //this.setState({ postData: this.props.filteredData });
    }

    if (this.props.value !== prevProps.value) {

      this.setState({ postData: this.props.filteredPosts.filteredData, visibility: '' });
      if (this.props.filteredPosts.filteredData.length > this.state.count) {
        
        // show hide/show button if filtered again
        this.setState({ showMoreVisibility: 'show', count: 6 });
      } else {
        this.setState({ showMoreVisibility: 'hide', count: 6 });
      }

      if (this.props.filteredPosts.filteredData.length !== 0) {
        this.setState({
          people: this.props.filteredPosts.filteredData,
          visibility: '',
          zeroResults: false
        });
      } else {
        this.setState({ zeroResults: true });
      }
    }
  }

  handleClick() {
    let count = this.state.count;
    let increment = 6;

    count += increment;
    this.setState({
      count: count
    });

    // hide/show button if less than 6 posts
    if (count <= this.props.filteredPosts.filteredData.length) {
      this.setState({
        showMoreVisibility: 'show'
      });
    } else {
      this.setState({
        showMoreVisibility: 'hide',
        count: this.props.filteredPosts.filteredData.length
      });
    }
  }

  render() {
    if (this.state.zeroResults === false) {
      return (
        <div>
          <div className="viewing d-flex justify-content-end">
            <span className="">
              Viewing{' '}
              {this.state.postData.length >= 6 ? this.state.count : this.state.postData.length} of{' '}
              {this.props.filteredPosts.filteredData.length}
            </span>
          </div>
          <div className="row">{this.buildPost()}</div>
          <div className="row d-flex justify-content-center">
            <ShowMore
              showMoreVisibility={this.state.showMoreVisibility}
              handleClick={() => {
                this.handleClick();
              }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="row">
          <p className="font-prussian-blue font-weight-600 text-center">
            No results. Try adjusting the filters, or click the clear filters button.
          </p>
        </div>
      );
    }
  }
}

Posts.propTypes = {
  postData: PropTypes.array,
  type: PropTypes.string,
  filteredPeople: PropTypes.object
};

const mapDispatchToProps = dispatch => {
  return {
    peopleDataAll: (loaded, data) => dispatch(peopleDataLoaded(loaded, data))
  };
};

const mapStateToProps = state => {
  return {
    postData: state.postData.data,
    type: state.postData.type,
    filteredPosts: state.postData,
    filters: state.filters,
    value: state.postData.value
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Posts);
